import {FloatingProvider, FloatingReferenceTrigger, useFloating} from '../../../floating'
import {FloatingSelectLayout} from '../select_layout'

export const FloatingSelect = ({
	ref,
	trigger,
	triggerEvent,
	placement = 'bottom-start',
	sharedProps,
	maxHeight = 500,
	open,
	onOpenChange,
	disabled,
	...providerProps
}) => {
	const showSearch = providerProps.search?.showSearch || providerProps.items.length > 10
	const floating = useFloating({placement, maxHeight, open, onOpenChange, keepPlacementAfterInitialFlip: showSearch})
	const {isNested} = floating

	const defaultTriggerEvent = isNested ? 'hover' : 'click'
	triggerEvent = triggerEvent || defaultTriggerEvent

	const config = {
		hover: {enabled: triggerEvent === 'hover'},
		disabled,
	}

	return (
		<FloatingProvider floating={floating} config={config} isNested={isNested}>
			<FloatingReferenceTrigger ref={ref} trigger={trigger} disabled={disabled} showRightArrowIfNested />
			<FloatingSelectLayout isNested={isNested} sharedProps={sharedProps} {...providerProps} />
		</FloatingProvider>
	)
}
